export type HtmlAudioPlayable = {
  play: () => Promise<void>;
  pause: () => void;
};

export type HtmlAudioPlayResult =
  | { status: "played" }
  | { status: "aborted" }
  | { status: "failed"; errorName: string; errorMessage: string };

export function playRejectionKind(error: unknown): "aborted" | "failed" {
  const name = error instanceof Error ? error.name : "";
  if (name === "AbortError") {
    return "aborted";
  }
  return "failed";
}

/** Calls HTMLAudioElement.play() and classifies the promise rejection. */
export async function playHtmlAudio(audio: HtmlAudioPlayable): Promise<HtmlAudioPlayResult> {
  try {
    await audio.play();
    return { status: "played" };
  } catch (error) {
    if (playRejectionKind(error) === "aborted") {
      return { status: "aborted" };
    }
    const errorName = error instanceof Error ? error.name : "Error";
    const errorMessage = error instanceof Error ? error.message : "play_failed";
    return { status: "failed", errorName, errorMessage };
  }
}

export function pauseHtmlAudio(audio: HtmlAudioPlayable): void {
  audio.pause();
}

/** Visually hidden without `display: none`, which Safari/iOS refuse to play. */
export const AUDIO_VISUALLY_HIDDEN_CLASS =
  "pointer-events-none absolute h-px w-px overflow-hidden opacity-0";

